<div style="padding: 1%">
  <nz-tabset nzSize="large">
    <nz-tab nzTitle="Inputs & DatePickers">
      <h2>Inputs</h2>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <h3>Простой инпут</h3>
          <input nz-input placeholder="large size" nzSize="large"/>
        </div>
        <div nz-col nzSpan="6">
          <h3>Префикс и суффикс инпут</h3>
          <nz-input-group [nzPrefix]="bccLogo" [nzSuffix]="counterAgentIcon" nzSize="large">
            <input type="text" nz-input placeholder="Большой префикс суффикс"/>
          </nz-input-group>
        </div>
        <div nz-col nzSpan="6">
          <h3>Префикс инпут</h3>
          <nz-input-group [nzPrefix]="bccLogo" nzSize="large">
            <input type="text" nz-input placeholder="Большой префикс"/>
          </nz-input-group>
        </div>
        <div nz-col nzSpan="6">
          <h3>Суффикс инпут</h3>
          <nz-input-group [nzSuffix]="counterAgentIcon" nzSize="large">
            <input type="text" nz-input placeholder="Большой суффикс"/>
          </nz-input-group>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <input nz-input placeholder="default size"/>
        </div>

        <div nz-col nzSpan="6">
          <nz-input-group [nzPrefix]="bccLogo" [nzSuffix]="counterAgentIcon">
            <input type="text" nz-input placeholder="Средний префикс суффикс"/>
          </nz-input-group>
        </div>
        <div nz-col nzSpan="6">
          <nz-input-group [nzPrefix]="bccLogo">
            <input type="text" nz-input placeholder="Средний префикс"/>
          </nz-input-group>
        </div>
        <div nz-col nzSpan="6">
          <nz-input-group [nzSuffix]="counterAgentIcon">
            <input type="text" nz-input placeholder="Средний суффикс"/>
          </nz-input-group>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <input nz-input placeholder="small size" nzSize="small"/>
        </div>
        <div nz-col nzSpan="6">
          <nz-input-group [nzPrefix]="bccLogo" [nzSuffix]="counterAgentIcon" nzSize="small">
            <input type="text" nz-input placeholder="Малый префикс суффикс"/>
          </nz-input-group>
        </div>
        <div nz-col nzSpan="6">
          <nz-input-group [nzPrefix]="bccLogo" nzSize="small">
            <input type="text" nz-input placeholder="Малый префикс"/>
          </nz-input-group>
        </div>
        <div nz-col nzSpan="6">
          <nz-input-group [nzSuffix]="counterAgentIcon" nzSize="small">
            <input type="text" nz-input placeholder="Малый суффикс"/>
          </nz-input-group>
        </div>
      </div>
      <hr/>
      <h2>Date pickers</h2>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <nz-date-picker nzSize="large" [nzFormat]="dateFormat"></nz-date-picker>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <nz-date-picker [nzFormat]="dateFormat"></nz-date-picker>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <nz-date-picker nzSize="small" [nzFormat]="dateFormat"></nz-date-picker>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <nz-range-picker></nz-range-picker>
        </div>
      </div>
      <h2>Select</h2>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <nz-select nzSize="large" nzPlaceHolder="Select option">
            <nz-option nzValue="opt 1" nzLabel="opt 1"></nz-option>
          </nz-select>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <nz-select nzSize="default" nzPlaceHolder="Select option">
            <nz-option nzValue="opt 1" nzLabel="opt 1"></nz-option>
          </nz-select>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <nz-select nzSize="small" nzPlaceHolder="Select option">
            <nz-option nzValue="opt 1" nzLabel="opt 1"></nz-option>
          </nz-select>
        </div>
      </div>

    </nz-tab>
    <nz-tab nzTitle="Кнопки">
      <h2>Примеры кнопок</h2>
      <!--Примеры больших кнопок-->
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <button nz-button nzType="primary" nzSize="large">Большая кнопка</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="large" class="secondaryBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="large" class="outlineBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="large" class="tertiaryBtn">Текст</button>
        </div>
      </div>
      <!--Примеры средних кнопок-->
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <button nz-button nzType="primary">Средняя кнопка</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" class="secondaryBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" class="outlineBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" class="tertiaryBtn">Текст</button>
        </div>
      </div>

      <!--Примеры малых кнопок почти везде они в системе-->
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <button nz-button nzType="primary" nzSize="small">SM кнопка</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="small" class="secondaryBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="small" class="outlineBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="small" class="tertiaryBtn">Текст</button>
        </div>
      </div>
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <button nzLoading nz-button nzType="primary" nzSize="small">SM кнопка</button>
        </div>
        <div nz-col nzSpan="6">
          <button nzLoading nz-button nzType="default" nzSize="small" class="secondaryBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nzLoading nz-button nzType="default" nzSize="small" class="outlineBtn">Текст</button>
        </div>
        <div nz-col nzSpan="6">
          <button nzLoading nz-button nzType="default" nzSize="small" class="tertiaryBtn">Текст</button>
        </div>
      </div>
      <!--Примеры малых кнопок почти везде они в системе-->
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="6">
          <button nz-button nzType="primary" nzSize="small" disabled>Кнопка disabled</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="small" class="secondaryBtn" disabled>Кнопка disabled</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="small" class="outlineBtn" disabled>Кнопка disabled</button>
        </div>
        <div nz-col nzSpan="6">
          <button nz-button nzType="default" nzSize="small" class="tertiaryBtn" disabled>Кнопка disabled</button>
        </div>
      </div>

    </nz-tab>
    <nz-tab nzTitle="Типография">
      <div nz-row [nzGutter]="gutter">
        <div nz-col nzSpan="24">
          <hr/>
          <h2>Примеры цветов фона и текста</h2>

          <div nz-col nzSpan="24">
            <h1>Заголовок H1</h1>
            <h2>Заголовок H2</h2>
            <h3>Заголовок H3</h3>
            <h4>Заголовок H4</h4>
            <h5>Заголовок H5</h5>
            <h6>Заголовок H6</h6>
          </div>

          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>
          <p class="bg-main text-light">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>
          <p class="text-blue">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>

          <p class="bg-blue text-light">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>
          <p class="text-secondary">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>
          <p class="bg-secondary text-light">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>

          <p class="text-red">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>

          <p class="bg-red text-light">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's
            standard dummy text ever since the 1500s, when an unknown printer.
          </p>


        </div>
      </div>
    </nz-tab>
    <nz-tab nzTitle="Другие UI компоненты">
      <div nz-row [nzGutter]="gutter">
        <nz-spin nzSimple></nz-spin>
        <div nz-col nzSpan="24">
          <hr/>
          <h2>Другие UI компоненты</h2>
          <label nz-checkbox>Checkbox</label>
          <br/>
          <nz-checkbox-group [(ngModel)]="checkOptionsOne"></nz-checkbox-group>
        </div>
        <div nz-col nzSpan="24">
          <nz-radio-group>
            <label nz-radio nzValue="A">A</label>
            <label nz-radio nzValue="B">B</label>
            <label nz-radio nzValue="C">C</label>
            <label nz-radio nzValue="D">D</label>
          </nz-radio-group>
        </div>
        <div nz-col nzSpan="24">
          <nz-radio-group nzName="radiogroup" class="ant-radio-bcc">
            <label nz-radio nzValue="A">A</label>
            <label nz-radio nzValue="B">B</label>
            <label nz-radio nzValue="C">C</label>
            <label nz-radio nzValue="D">D</label>
          </nz-radio-group>
        </div>
        <div nz-col nzSpan="24">
          <nz-switch></nz-switch>
        </div>
      </div>
    </nz-tab>
  </nz-tabset>
</div>
<ng-template #bccLogo><i nz-icon><img src="assets/icons/BCC_logo.svg"/></i></ng-template>
<ng-template #counterAgentIcon><i nz-icon><img src="assets/icons/Contragent/M.svg"/></i></ng-template>
